import React from 'react';
import moment from 'moment';

const FarmManager = ({ menuOpen, data, task }) => {
  return (
    <div
      className={`flex flex-wrap justify-center mt-10 px-5 md:px-0 ${menuOpen ? 'md:pl-24' : ''}`}
    >
      <div className="w-full md:w-4/5 lg:w-133 bg-white rounded px-6 py-4">
        <div className="flex items-center">
          <div className="md:block h-16 w-1/12 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300 my-3 block">
            <img
              src={data.farm.product.manager.photoUrl}
              alt={data.farm.product.manager.firstName}
              className="block md:inline-block object-cover"
            />
          </div>
          <div className="ml-6 w-11/12">
            <h5 className="border-b-2 border-green-600 text-sm md:text-base overflow-hidden pb-2">
              From Farm Manager {data.farm.product.manager.firstName}{' '}
              {data.farm.product.manager.lastName} on Crop Stage
            </h5>
            <span className="block text-sm py-2">{moment(task.updatedAt).fromNow()}</span>
            <p className="text-sm md:text-base">{task.comment}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmManager;
